import {findPartnerPaymentsCard} from "../Util/queries"
import {PARTNER_CREDIT_CARD_INFO} from "../Components/Payments/creditCardInfoSection";
import {constructPartnerCardDetails} from "../Factory/factory";

export const GetPartnerCardDetails = () =>
    async (dispatch) => {
        try {
            let response = await findPartnerPaymentsCard();
            if (response.data?.cardInfo) {
                let cardInfo = response.data.cardInfo;
                dispatch({
                    type: PARTNER_CREDIT_CARD_INFO,
                    payload: constructPartnerCardDetails(cardInfo.last4Digit, cardInfo.expireMonth, cardInfo.expireYear)
                })
            } else {
                dispatch({
                    type: PARTNER_CREDIT_CARD_INFO,
                    payload: null
                })
            }
        } catch (e) {
            dispatch({
                type: PARTNER_CREDIT_CARD_INFO,
                payload: null
            })
        }
    }
